<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="1200px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @open="handleOpen('dialog')"
  >
    <div
      v-loading="loading"
      :loading="loading"
      :element-loading-text="loadingText"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div class="container-box">
        <!-- 数据列表 -->
        <div class="table-wrap table-list-show">
          <view-table
            :table-columns="tableColumns"
            :table-data="tableData"
          />
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
// 自定义Table
import ViewTable from '@/components/viewTable'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin from '@/mixin/dialogTableCustomMixin'
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 数据请求
import { getDoubleInfoByConditionApi } from '@/api/store'
export default {
  name: 'MaterialList',
  components: { ViewTable },
  mixins: [dialogDragMixin, dialogTableCustomMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    },
    selectItem: {
      type: Object,
      default: null
    },
    viewType: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      loading: false,
      loadingText: '努力加载数据中，请耐心等待',
      tableColumns: [],
      tableData: []
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.loading = true
        this.tableData = []
        this.tableColumns = [
          { prop: 'provinceName', label: '省区', width: 120},
          { prop: 'cityName', label: '城市', width: 120},
          { prop: 'countyName', label: '区域', width: 120},
          { prop: 'certificateNo', label: '专卖证号', width: 120 },
          { prop: 'storeName', label: '店名', width: 120 },
          { prop: 'address', label: '地址', width: 120 },
          { prop: 'realStoreName', label: '实际店名', width: 120 },
          { prop: 'realAddress', label: '实际地址', width: 120 },
          { prop: 'ownerName', label: '店主', width: 120 },
          { prop: 'phone', label: '电话', width: 120 },
          { prop: 'manageUserName', label: '维护人', width: 180 }
        ]
        this.searchData()
      }
    }
  },
  methods: {
    // 查询
    searchData () {
      let params = {
        provinceId: this.selectItem.provinceIds
      }
      if (this.viewType === 1) {
        params.type = 1
      } else if (this.viewType === 2) {
        params.type = 2
      }
      getDoubleInfoByConditionApi(params).then(response => {
        this.tableData = response.data ? response.data : []
        this.loading = false
      })
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    }
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
</style>
/>